import CertidoesCRCService from '@/services/CertidoesCRCService'
import ProvimentoTrezeService from '@/services/ProvimentoTrezeService'

const RELEASES_NOTES = 'RELEASES_NOTES'
const CURRENT_RELEASE_NOTE = 'CURRENT_RELEASE_NOTE'
const NUMBER_UNREAD_RELEASES = 'NUMBER_UNREAD_RELEASES'
const NUMBER_UNREAD_PEDIDOS = 'NUMBER_UNREAD_PEDIDOS'
const IS_OPEN_SIDE_BAR_RELEASES_NOTES = 'IS_OPEN_SIDE_BAR_RELEASES_NOTES'
const CLICKED_ON = 'CLICKED_ON'
const PEDIDOS_PENDENTES_CRC = 'PEDIDOS_PENDENTES_CRC'  // Novo nome para os pedidos pendentes
const PEDIDOS_PENDENTES_CRC_BASE = 'PEDIDOS_PENDENTES_CRC_BASE'
const PEDIDOS_PENDENTES_P13 = 'PEDIDOS_PENDENTES_P13'

export default {
  namespaced: true,
  state: {
    releases: [],
    currentRelease: {},
    numberUnreadReleases: null,
    isOpenSideBarReleasesNotes: false,
    clickedOn: '',
    pedidos: [],
    pedidosBase: [],
    pedidosp13: [],
  },
  getters: {
    getReleases: (state) => state.releases,
    getPedidosPendentes: (state) => state.pedidos,
    getPedidosPendentesP13: (state) => state.pedidos_provimento_treze,
    getNumberUnreadPedidosP13: (state) => state.numberUnreadPedidosP13,
    getNumberUnreadPedidos: (state) => state.numberUnreadPedidos,
    getCurrentRelease: (state) => state.currentRelease,
    getNumberUnreadReleases: (state) => state.numberUnreadReleases,
    getIsOpenSideBarReleasesNotes: (state) => state.isOpenSideBarReleasesNotes,
    getClickedOn: (state) => state.clickedOn,
    getPedidosPendentesBase: (state) => state.pedidosBase
  },
  mutations: {
    [RELEASES_NOTES] (state, status) {
      state.releases = status
    },
    [CURRENT_RELEASE_NOTE] (state, status) {
      state.currentRelease = status
    },
    [NUMBER_UNREAD_RELEASES] (state, status) {
      state.numberUnreadReleases = status
    },
    [NUMBER_UNREAD_PEDIDOS] (state, status) {
      state.numberUnreadPedidos = status
    },
    [IS_OPEN_SIDE_BAR_RELEASES_NOTES] (state, status) {
      state.isOpenSideBarReleasesNotes = status
    },
    [CLICKED_ON] (state, status) {
      state.clickedOn = status
    },
    [PEDIDOS_PENDENTES_CRC] (state, pedidos) {
      state.pedidos = pedidos  // Atualiza o estado com os pedidos pendentes
    },
    [PEDIDOS_PENDENTES_CRC_BASE] (state, pedidos) {
      state.pedidosBase = pedidos
    },
    [PEDIDOS_PENDENTES_P13] (state, pedidos) {
      state.pedidos_provimento_treze = pedidos  // Atualiza o estado com os pedidos pendentes P13
    },
  },
  actions: {
    setSaveReleasesData ({ commit }, { data, unreadCount }) {
      // Salvar os dados de Releases Notes
      commit(RELEASES_NOTES, data)

      // Definir o número de Releases Notes não lidas
      commit(NUMBER_UNREAD_RELEASES, unreadCount)
    },
    setSaveCurrentReleaseData ({ commit }, { data }) {
      // Atualiza o estado com as informações mais recentes sobre o release atual
      commit(CURRENT_RELEASE_NOTE, data)
    },
    setSaveIsOpenSideBarReleasesNotesData ({ commit }, { data, clickedOn }) {
      commit(IS_OPEN_SIDE_BAR_RELEASES_NOTES, data)

      // Indica qual o ícone que foi clicado no sideBar
      commit(CLICKED_ON, clickedOn)


      // Se for "pedidosPendentesCrc", chama a ação para buscar os pedidos pendentes
      if (clickedOn === 'clickedOnCertidoesPendentesCRC') {
        this.dispatch('releasesNotes/fetchPedidosPendentes', { data: ''})
      }
      
      if (clickedOn === 'clickedOnPedidosPendentesP13') {
        this.dispatch('releasesNotes/fetchPedidosPendentesP13')
      }
    },

    async fetchPedidosPendentesP13 ({ commit }) {
      try {
        // Chama o serviço para obter os pedidos pendentes

        const response = await ProvimentoTrezeService.obterPedidosPendentes()
        
        // Verifica se a resposta é válida e contém dados
        if (response && response.data && response.data.rows.length) {
          commit(PEDIDOS_PENDENTES_P13, response.data.rows)  // Atualiza o estado com os pedidos pendentes
        } else {
          commit(PEDIDOS_PENDENTES_P13, [])  // Caso não haja dados, define como array vazio
        }
      } catch (error) {
        console.error('Erro ao obter pedidos pendentes:', error)
        commit(PEDIDOS_PENDENTES_P13, [])  // Em caso de erro, define como array vazio
      }
    },

    async fetchPedidosPendentes ({ commit }, { data }) {
      try {
        // Chama o serviço para obter os pedidos pendentes
        const response = await CertidoesCRCService.obterTodosPedidos(data)
        // Verifica se a resposta é válida e contém dados
        if (response && response.data) {
          if (!data) commit(PEDIDOS_PENDENTES_CRC_BASE, response.data) // Salva a base inicial dos pedidos pendentes
          else commit(PEDIDOS_PENDENTES_CRC, response.data) // Atualiza o estado com os pedidos pendentes
        } else {
          commit(PEDIDOS_PENDENTES_CRC, [])  // Caso não haja dados, define como array vazio
        }
      } catch (error) {
        console.error('Erro ao obter pedidos pendentes:', error)
        commit(PEDIDOS_PENDENTES_CRC, [])  // Em caso de erro, define como array vazio
      }
    }
  }
}
